import React from 'react'

import * as css from './MantenedorDistancias.css'
//Componentes
import { RowDistancias } from './RowDistancias.jsx'
import Sticky from '../../components/shared/react-sticky/sticky.js'
import StickyContainer from '../../components/shared/react-sticky/container.js'
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'

export class TablaDistancias extends React.Component{
    constructor(props){
        super(props)
        this.rows = []
        this.state = {
            inputDistancia: []
        }
    }
    focusRow(index, nombreElemento){
        let ultimoIndex = this.rows.length-1
        let elemento = nombreElemento
        if(index<0){
            // al seleccionar "antes de la primera", se seleciona el ultimo
            this.rows[ultimoIndex].focusElemento(elemento)
        }else if(index>=ultimoIndex){
            // al seleccionar "despues de la ultima", se selecciona el primero de la columna
            this.rows[0].focusElemento(elemento)
        }else{
            // no es ni el ultimo, ni el primero
            this.rows[index].focusElemento(elemento)
        }
    }
    render() {
        let cantidadComunasRow = this.props.comunasRow.length
        let cantidadComunasHeader = this.props.comunasHeader.length
        return (
            <StickyContainer type={React.DOM.table} className={"table table-bordered table-condensed "+css.tableFixed}>
                <colgroup>
                    <col className={css.colIndex}/>
                    <col className={css.colComuna}/>
                    {this.props.comunasHeader.map(comunaHeader=>{
                        return <col key={comunaHeader.cutComuna} className={css.colComuna}/>
                    })}
                </colgroup>
                <thead>
                    <Sticky
                    topOffset={-50}
                    type={React.DOM.tr}
                    stickyStyle={{top: '50px'}}>
                        <th className={css.thIndex}>#</th>
                        <th className={css.thComuna}>
                            <HeaderConFiltro
                                nombre='Comunas'
                                filtro={this.props.filtros.filtroComuna || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroComuna')}
                                busquedaExacta={true}
                            />
                        </th>
                        {this.props.comunasHeader.map(comunaHeader=>{
                            return <th key={comunaHeader.cutComuna} className={css.thComuna}>{comunaHeader.nombre}</th>
                        })}
                    </Sticky>
                </thead>
                <tbody>
                    {_.range(0, cantidadComunasRow).map(index=>{
                        let comunaRow = this.props.comunasRow[index]
                        return <RowDistancias
                            key={index}
                            index={index}
                            ref={ref=>this.rows[index]=ref}
                            focusRow={this.focusRow.bind(this)}
                            comunaRow={comunaRow}
                            cantidadComunasHeader={cantidadComunasHeader}
                            comunasHeader={this.props.comunasHeader}
                        />
                    })}
                </tbody>
            </StickyContainer>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/distancias/TablaDistancias.jsx